import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((16),function(i){return _c(VSkeletonLoader,{key:("candidate-list-skeleton-index--" + i),attrs:{"type":"list-item-avatar-three-line"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }